"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exceedsTolerance = exports.roundToDecimalPlaces = exports.sumValues = void 0;
/**
 * Calculates the sum of all numeric values in the given object.
 * If the object is undefined or null, returns 0.
 * Non-numeric values are treated as 0.
 *
 * @param values - The object containing the values to be summed.
 * @returns The sum of all numeric values in the object.
 */
const sumValues = (values) => Object.values(values !== null && values !== void 0 ? values : {}).reduce((prev, curr) => prev + (typeof curr === 'number' ? curr : 0), 0);
exports.sumValues = sumValues;
/**
 * Rounds a number to the specified decimal places.
 * If the number is undefined, returns 0.
 *
 * @param num - The number to round.
 * @param places - The number of decimal places to round to. Default is 2.
 * @returns The rounded number or 0 if the num is undefined.
 */
const roundToDecimalPlaces = (num, places = 2) => {
    // If the number is undefined, return undefined
    if (!num) {
        return 0;
    }
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};
exports.roundToDecimalPlaces = roundToDecimalPlaces;
/**
 * Checks if the difference between two numbers exceeds a given tolerance.
 * @param actual - The actual number.
 * @param predicted - The predicted number.
 * @param tolerance - The tolerance value (default: 0.1).
 * @returns True if the difference exceeds the tolerance, false otherwise.
 */
const exceedsTolerance = (actual, predicted, tolerance = 0.1) => {
    const difference = Math.abs(actual - predicted) / actual * 100;
    return difference > tolerance;
};
exports.exceedsTolerance = exceedsTolerance;
